export enum AnnouncementConfirmationRequirement {
  TAK = 'TAK',
  NIE = 'NIE',
  NIE_DOTYCZY = 'NIE_DOTYCZY',
}

export const ANNOUNCEMENT_CONFIRMATION_REQUIREMENT_LABELS: Record<
  AnnouncementConfirmationRequirement,
  string
> = {
  [AnnouncementConfirmationRequirement.TAK]: 'Tak',
  [AnnouncementConfirmationRequirement.NIE]: 'Nie',
  [AnnouncementConfirmationRequirement.NIE_DOTYCZY]: 'Nie dotyczy',
};
